import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CustomerVenueGroup, CustomerVenueGroupType } from "src/app/shared/models/CustomerVenueGroup.item";
import { CompareOperator } from "src/app/shared/models/enums/compare-operator.enum";
import { CustomerVenueGroupCriteria } from "src/app/shared/models/enums/customer-venue-group-criteria.enum";
import * as uuid from "uuid";

@Component({
	selector: "app-groups",
	templateUrl: "./groups.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class GroupsComponent implements OnInit {
	customerGroupList: CustomerVenueGroup[];
	customerGroupSelected: CustomerVenueGroup;

	moment: any = moment;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		public venueService: OOVenueService,
		public userService: UserService,
		public customerService: CustomerService
	) {}

	ngOnInit(): void {
		this.init();
	}

	async init() {
		this.groupGet();
		if (this.customerService.currentVenueKey !== this.venueService.subscriptionVenue.value.key || this.customerService.customerList.value.length === 0) {
			this.customerService.initCustomerService();
		}
	}

	async groupGet() {
		const resp = await this.focuslink.customerGroupsGet(this.venueService.subscriptionVenue.value.key);
		const updateGroupResults: string[] = [];
		this.customerGroupList = resp.map((i) => {
			const cg = new CustomerVenueGroup(i);
			cg.design = this.groupDescription(cg);
			if ((cg.lastCountDateTime && moment(cg.lastCountDateTime).add(1, "day").isSameOrBefore(moment())) || !cg.lastCountResult) {
				updateGroupResults.push(cg.sk);
			}
			return cg;
		});
	}

	async groupSave(rec: CustomerVenueGroup) {
		const idx = this.customerGroupList.findIndex((i) => i.sk === rec.sk);
		rec.design = this.groupDescription(rec);
		if (idx != -1) {
			this.customerGroupList[idx] = rec;
		} else {
			this.customerGroupList.push(rec);
		}
		this.customerGroupSelected = undefined;

		this.customerGroupList = [...this.customerGroupList];
	}

	customerGroupNew() {
		this.customerGroupSelected = new CustomerVenueGroup({
			pk: this.venueService.subscriptionVenue.value.key.toString(),
			sk: uuid.v4(),
			type: 1,
		});
	}

	groupDelete(groupKey: string) {
		this.focuslink.customerGroupDelete(this.venueService.subscriptionVenue.value.key, groupKey);
		this.customerGroupList.splice(
			this.customerGroupList.findIndex((i) => i.sk === groupKey),
			1
		);
		this.customerGroupList = [...this.customerGroupList];
	}

	groupDescription(cg: CustomerVenueGroup): string {
		switch (cg.type) {
			case CustomerVenueGroupType.ALL:
				return "All customers";
			case CustomerVenueGroupType.DYNAMIC:
				break;
			case CustomerVenueGroupType.STATIC:
				return `${cg.customerKeyList?.length} customers`;
		}
		let descript: string = "";

		switch (cg.criteria) {
			case CustomerVenueGroupCriteria.AVERAGESPEND:
				descript = "Average Spend is ";
				break;
			case CustomerVenueGroupCriteria.FIRSTVISIT:
				descript = "First visit date is ";
				break;
			case CustomerVenueGroupCriteria.LASTVISIT:
				descript = "Last visit date is ";
				break;
			case CustomerVenueGroupCriteria.PURCHASEDITEM:
				descript = "Has purchased ";
				break;
			case CustomerVenueGroupCriteria.TOTALREVENUE:
				descript = "Total spend is ";
				break;
			case CustomerVenueGroupCriteria.VISITCOUNT:
				descript = "Has visited ";
				break;
			default:
				descript = "Average Spend is ";
				break;
		}

		switch (cg.operator) {
			case CompareOperator.BETWEEN:
				descript += "between ";
				break;
			case CompareOperator.EQUALS:
				descript += "equal to ";
				break;
			case CompareOperator.GREATERTHAN:
				descript += "greater than ";
				break;
			case CompareOperator.GREATERTHANEQUALTO:
				descript += "greater than or equal to ";
				break;
			case CompareOperator.LESSTHAN:
				descript += "less than ";
				break;
			case CompareOperator.LESSTHANEQUALTO:
				descript += "less than or equal to ";
				break;
			default:
				descript += "greater than or equal to ";
				break;
		}

		if (cg.operator === CompareOperator.BETWEEN) {
			if (cg.criteria === CustomerVenueGroupCriteria.FIRSTVISIT || cg.criteria === CustomerVenueGroupCriteria.LASTVISIT) {
				descript += `${moment(cg.value).format("l")} and ${moment(cg.value2).format("l")}`;
			} else {
				descript += `${cg.value} and ${cg.value2}`;
			}
		} else {
			descript += cg.value;
		}
		return descript;
	}
}
